define('plugin/invoice/view/InvoiceRecurringProfileLayout',['require','lib/view/LayoutView','plugin/invoice/view/InvoiceRecurringProfileInvoiceListView','plugin/invoice/view/InvoiceRecurringProfileView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var InvoiceRecurringProfileInvoiceListView = require('plugin/invoice/view/InvoiceRecurringProfileInvoiceListView');
    var InvoiceRecurringProfileView = require('plugin/invoice/view/InvoiceRecurringProfileView');

    /**
     * Invoice recurring profile details layout
     *
     * @class InvoiceRecurringProfileLayout
     */
    return LayoutView.extend({

        template: '#invoice_recurring_profile_layout',
        regions: {
            'list': '#sb_invoice_list',
            'details': '#sb_profile_details'
        },
        childEvents: {
            'profile:cancel': 'triggerCancelProfile'
        },

        displayInvoiceCollection: function () {
            this.showChildView('list', new InvoiceRecurringProfileInvoiceListView({
                collection: this.getOption('collection'),
                label: 'invoices_list',
                url: this.getOption('pagerUrl')
            }));
        },

        displayProfileDetails: function () {
            this.showChildView('details', new InvoiceRecurringProfileView({
                model: this.getOption('model')
            }));
        },

        triggerCancelProfile: function () {
            this.triggerMethod('profile:cancel', this.getOption('model'));
        }

    });

});
